// ---------------------------------------------- modules import
import { UserAction, UserActionType } from "./common";

// ---------------------------------------------- action creators
class Actions {
  static addBegin = (): UserAction => ({
    type: UserActionType.ADD_USER_BEGIN
  });

  static addSuccess = (): UserAction => ({
    type: UserActionType.ADD_USER_SUCCESS
  });

  static addError = (error: string): UserAction => ({
    type: UserActionType.ADD_USER_ERROR,
    payload: {
      error
    }
  });

  static updateBegin = (): UserAction => ({
    type: UserActionType.UPDATE_USER_BEGIN
  });

  static updateSuccess = (): UserAction => ({
    type: UserActionType.UPDATE_USER_SUCCESS
  });

  static updateError = (error: string): UserAction => ({
    type: UserActionType.UPDATE_USER_ERROR,
    payload: {
      error
    }
  });

  static deleteBegin = (): UserAction => ({
    type: UserActionType.DELETE_USER_BEGIN
  });

  static deleteSuccess = (): UserAction => ({
    type: UserActionType.DELETE_USER_SUCCESS
  });

  static deleteError = (error: string): UserAction => ({
    type: UserActionType.DELETE_USER_ERROR,
    payload: {
      error
    }
  });
}

export default Actions;
